import { useState } from 'react'
import { useMutation } from '@tanstack/react-query'

import { updatePasswordApi } from '@!/Api/user'

export const useUpdatePassword = () => {
  const [status, setStatus] = useState(null)
  const [apiError, setApiError] = useState(null)

  const updatePasswordMutation = useMutation({
    mutationFn: ({ currentPassword, newPassword }) => updatePasswordApi(currentPassword, newPassword),
    onSuccess: () => {
      setStatus('success')
    },
    onError: (error) => {
      setApiError(null)
      if (error.data && error.data.error) {
        setApiError(error.data.error)
      } else {
        setApiError('unknown_error')
      }
      setStatus('fail')
    },
  })

  return [updatePasswordMutation, status, apiError]
}
